    import React, { Component } from 'react';
    import { Container, Row, Col, Form, Table, Card, Button } from 'react-bootstrap';
    import { DatePicker } from 'antd';
    import moment from 'moment';
    import Side from './Sidebar';
    import Top from './Topbar';
    import C from '../lib/Config';
    import swal from 'sweetalert';
    import { FaTimesCircle } from 'react-icons/fa';
    import '../App.css';

    export default class ChemoAppointment extends Component {

        exportToPDF = () => {
            const { filteredData } = this.state;
            const printWindow = window.open('', '_blank');
            const style = `
                <style>
                    table { 
                        border-collapse: collapse; 
                        width: 100%;
                        font-size: 8px; 
                    }
                    th, td { 
                        border: 1px solid #ddd; 
                        padding: 4px; 
                        text-align: left;
                        word-wrap: break-word;
                        max-width: 150px;
                    }
                    th { 
                        background-color: #6c757d; 
                        color: white; 
                    }
                    @media print {
                        @page {
                            size: landscape;
                            margin: 10mm;
                        }
                    }
                </style>
            `;
        
            const currentDate = new Date().toLocaleString();
            const headerRow = Object.values(this.getHeaderConfig()).map(config => 
                `<th>${config.label}</th>`
            ).join('');
        
            const rows = filteredData.flatMap(patient => 
                patient.treatmentPlans.map(plan => `
                    <tr>
                        <td>${patient.patientName}</td>
                        <td>${patient.age}/${patient.gender}</td>
                        <td>${patient.dob}</td>
                        <td>${patient.mrNo}</td>
                        <td>${patient.address}</td>
                        <td>${patient.phone}</td>
                        <td>${patient.currentCancerSites }</td>
                        <td>${patient.consultantName}</td>
                        <td>${plan.chemoDetails && plan.chemoDetails.length > 0 ? 
                            plan.chemoDetails.map(chemo => 
                                moment(chemo.chemoDate).format('DD-MM-YYYY')
                            ).join('<br/>') : 'N/A'}
                        </td>
                        <td>${plan.chemotherapyCourse}</td>
                        <td>${plan.chemotherapyName}</td>
                        <td>${patient.appointmentDt}</td>
                        <td>${patient.dischargeDate}</td>
                        <td>${this.formatStagingDetails(patient.stagingDetails[0])}</td>
                        ${this.state.isRestrictedFieldsVisible ? `
                            <td>${patient.category}</td>
                            <td>${patient.company}</td>
                            <td>${patient.tariff}</td>
                            <td>${patient.payType}</td>
                        ` : ''}
                    </tr>
                `).join('')
            );
        
            const html = `
                <html>
                    <head>
                        <title>Chemo Appointment Report</title>
                        ${style}
                    </head>
                    <body>
                        <h2>Chemo Appointment Report</h2>
                        <p>Generated on: ${currentDate}</p>
                        <table>
                            <thead>
                                <tr>${headerRow}</tr>
                            </thead>
                            <tbody>${rows}</tbody>
                        </table>
                    </body>
                </html>
            `;
        
            printWindow.document.write(html);
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
            }, 500);
        };
        
        exportToExcel = () => {
            const { filteredData } = this.state;
            let csvContent = "data:text/csv;charset=utf-8,";
            
            // Headers
            const headers = Object.values(this.getHeaderConfig()).map(config => config.label);
            csvContent += headers.join(',') + '\n';
            
            // Data
            filteredData.forEach(patient => {
                patient.treatmentPlans.forEach(plan => {
                    const row = [
                        patient.patientName,
                        `${patient.age}/${patient.gender}`,
                        patient.dob,
                        patient.mrNo,
                        this.escapeCSV(patient.address),
                        this.escapeCSV(`${patient.phone}`),
                        this.escapeCSV(patient.diagnosis),
                        this.escapeCSV(patient.consultantName),
                        this.escapeCSV(patient.appointmentDt),
                        this.escapeCSV(patient.dischargeDate),
                        // plan.details || 'N/A',
                        this.escapeCSV(plan.chemotherapyCourse),
                        this.escapeCSV(patient.referralDoctorName),
                        this.escapeCSV(plan.chemotherapyName),
                        this.escapeCSV(moment(plan.chemoDate).format('DD-MM-YYYY')),
                        this.escapeCSV(this.formatStagingDetails(patient.stagingDetails[0])),
                    ];
        
                    if (this.state.isRestrictedFieldsVisible) {
                        row.push(
                            patient.category,
                            patient.company,
                            patient.tariff,
                            patient.payType
                        );
                    }
                    
                    csvContent += row.join(',') + '\n';
                });
            });
        
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'ChemoPlanReport.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        
        formatStagingDetails = (staging) => {
            if (!staging) return 'N/A';
            return `T:${staging.tStage} N:${staging.nStage} M:${staging.mStage}`;
        };
        
        escapeCSV = (str) => {
            if (!str) return '';
            return `"${str.replace(/"/g, '""')}"`;
        };
        
        getHeaderConfig = () => ({
            patientName: { label: 'Patient Name' },
            ageGender: { label: 'Age/Gender' },
            dob: { label: 'DOB' },
            mrNo: { label: 'MR No' },
            address: { label: 'Address' },
            contactDetails: { label: 'Contact Details' },
            diagnosis: { label: 'Diagnosis' },
            consultant: { label: 'Name of Consultant' },
            // details: { label: 'Details' },
            chemoDates: { label: 'Chemo Cycles Dates' },
            referralDoctor: { label: 'Referral Doctor' }, // New
            appointmentDt: { label: 'Followup Date' },
            dischargeDate: { label: 'Discharge Date' },
            ...(this.state.isRestrictedFieldsVisible && {
                category: { label: 'Category' },
                company: { label: 'Company' },
                tariff: { label: 'Tarrif' },
                payType: { label: 'Pay Type' }
            }),
        });

        constructor(props) {
            super(props);
            this.state = {
            reportData: [], // Full dataset
            filteredData: [], // Data for display
            isRestrictedFieldsVisible: false, // Controls restricted fields visibility
            userId: localStorage.getItem('userId'),
            instituteArr: [],
            selectedInstitute: '',
            specificDate: null,
            tariff: '',
            patientName: '',
            doctorName: '',
            loading: false,
            error: null,
            tableVisible: false, // Controls table visibility on load
            tariffOptions: ['Select Tariff',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'],
            };
        }

        componentDidMount() {
            this.checkUserAccess();
            this.getAllInstitute();
        }

        checkUserAccess = () => {
            const userId = this.state.userId;
            if (userId === '90' || userId === '74') {
                this.setState({ isRestrictedFieldsVisible: true });
            }
        }

        getAllInstitute = () => {
            const userId = this.state.userId;
            return fetch(`${C.getUrl()}/institute/getAllInstituteByUserId/${userId}`)
                .then(res => res.json())
                .then(res => {
                    const arr = res.map(d => ({
                        id: d.instituteId,
                        name: d.instituteName
                    }));
                    this.setState({ 
                        instituteArr: arr,
                        selectedInstitute: arr.length === 1 ? arr[0].id : ''
                    });
                })
                .catch(err => {
                    swal({
                        title: "Error!",
                        text: "Error fetching institutes: " + err,
                        icon: "error",
                        buttons: false,
                        timer: 2000,
                    });
                });
        };
        handleSearch = () => {
            const { patientName, doctorName, specificDate, tariff } = this.state;
        
            if (!patientName && !doctorName && !specificDate && !tariff) {
                swal("Warning!", "Please enter atleast one filter criteria to search.", "warning");
                return;
            }
        
            this.fetchReportData();
            this.setState({ tableVisible: true });
        };
        

        fetchReportData = async () => {
            try {
                const { selectedInstitute, specificDate, tariff, patientName, doctorName } = this.state;
        
                if (!selectedInstitute && this.state.instituteArr.length > 1) {
                    return;
                }
        
                this.setState({ loading: true });
        
                // Base URL with instituteId
                let url = `${C.getUrl()}/patientData/allfilters?instituteId=${selectedInstitute}`;
        
                // Add userId if available
                if (this.state.userId) {
                    url += `&userId=${this.state.userId}`;
                }
        
                // Add chemoDate if specified
                if (specificDate) {
                    const formattedDate = moment(specificDate).format('DD-MM-YYYY');
                    url += `&chemoDate=${formattedDate}`;
                }
        
                // Add Tariff parameter
                if (tariff && tariff !== '') {
                    url += `&tariff=${tariff}`;
                }
        
                // Add Patient Name parameter
                if (patientName && patientName !== '') {
                    url += `&patientName=${patientName}`;
                }
        
                // Add Consultant Name parameter
                if (doctorName && doctorName !== '') {
                    url += `&consultantName=${doctorName}`;
                }
        
                const response = await fetch(url);
        
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
        
                const data = await response.json();
        
                // Process the data
                let processedData = this.processReportData(data);
        
                // If a specific date is selected, filter to show only matching rows
                if (specificDate) {
                    const searchDate = moment(specificDate).format('DD-MM-YYYY');
                    processedData = processedData.map(patient => ({
                        ...patient,
                        treatmentPlans: patient.treatmentPlans.map(plan => ({
                            ...plan,
                            chemoDetails: plan.chemoDetails.filter(chemo => 
                                moment(chemo.chemoDate).format('DD-MM-YYYY') === searchDate
                            )
                        })).filter(plan => plan.chemoDetails.length > 0)
                    })).filter(patient => patient.treatmentPlans.length > 0);
                }
        
                // Apply patient name and doctor name filters
                const filteredData = processedData.filter(item => {
                    const isPatientMatch = patientName
                        ? item.patientName.toLowerCase().includes(patientName.toLowerCase())
                        : true; // If no patient name entered, don't filter by it.
        
                    const isDoctorMatch = doctorName
                        ? item.consultantName.toLowerCase().includes(doctorName.toLowerCase())
                        : true; // If no doctor name entered, don't filter by it.
        
                    return isPatientMatch && isDoctorMatch;
                });
        
                this.setState({
                    reportData: processedData,
                    filteredData: filteredData,
                    loading: false,
                    tableVisible: true
                });
        
            } catch (error) {
                console.error('Error fetching report data:', error);
                this.setState({
                    error: error.message,
                    loading: false
                });
        
                swal({
                    title: "Error!",
                    text: error.message,
                    icon: "error",
                    buttons: false,
                    timer: 2000
                });
            }
        };

        processReportData = (data) => {
            return data.map((item) => {
                // let startDate = 'N/A';
                // let endDate = 'N/A';
                
                // if (item.treatmentPlans && item.treatmentPlans[0] && item.treatmentPlans[0].chemoDetails) {
                //     const chemoDates = item.treatmentPlans[0].chemoDetails
                //         .map(detail => new Date(detail.chemoDate))
                //         .sort((a, b) => a - b);
                    
                //     if (chemoDates.length > 0) {
                //         startDate = moment(chemoDates[0]).format('DD-MM-YYYY');
                //         endDate = moment(chemoDates[chemoDates.length - 1]).format('DD-MM-YYYY');
                //     }
                // }
        
                return {
                    patientId: item.patientId,
                    patientName: `${item.firstName} ${item.lastName}`,
                    age: item.patientAge,
                    gender: item.genderId === 1 ? 'Male' : 'Female',
                    phone: item.phoneNumber1,
                    address: `${item.addressLine1 || ''} ${item.addressLine2 || ''}`.trim(),
                    mrNo: item.mrNo !== '(NULL)' ? item.mrNo : 'N/A',
                    dob: moment(item.dob).format('DD-MM-YYYY'),
                    currentCancerSites: item.currentCancerSites || 'N/A',
                    consultantName: `${item.userFirstName || ''} ${item.userLastName || ''}`.trim() || 'N/A',
                    category: item.category || 'N/A',
                    company: item.company || 'N/A',
                    tariff: item.tariff || 'N/A',
                    payType: item.payType || 'N/A',
                    referralDoctorName: item.referralDoctorName || 'N/A',
                    appointmentDt: item.appointmentDt ? moment(item.appointmentDt).format('DD-MM-YYYY') : 'N/A',
                    dischargeDate: item.dischargeDate ? moment(item.dischargeDate).format('DD-MM-YYYY') : 'N/A',
                    treatmentPlans: this.processPlans(item.treatmentPlans),
                    stagingDetails: this.processStaging(item.stagingDetails)
                };
            });
        };

        processPlans = (plans) => {
            if (!plans || !Array.isArray(plans)) return [];
            return plans.map(plan => ({
                protocolName: plan.protocolName || 'N/A',
                
                nameOfConsultant: plan.nameOfConsultant || 'N/A',
                chemotherapyCourse: plan.protocolName || 'N/A',
                chemotherapyName: plan.protocolName || 'N/A',
                chemoDetails: plan.chemoDetails || []
            }));
        }

        processStaging = (staging) => {
            if (!staging || !Array.isArray(staging)) return [];
            return staging.map(stage => ({
                tStage: stage.tStage || 'N/A',
                nStage: stage.nStage || 'N/A',
                mStage: stage.mStage || 'N/A'
            }));
        }

    // Update handleDateChange to immediately show filtered results
    handleDateChange = (date) => {
        this.setState({ 
            specificDate: date
        });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ 
            [name]: value.trim()
             // Hide table when input changes
        });
    };
        
        

        filterByPatientName = () => {
            const { reportData, patientName, doctorName } = this.state;
        
            // Only filter if a valid patientName or doctorName is entered
            if (!patientName && !doctorName) {
                // No filters applied, show all data
                this.setState({ filteredData: reportData });
                return;
            }
        
            // Apply filters if inputs exist
            const filteredData = reportData.filter(item => {
                const isPatientMatch = patientName
                    ? item.patientName.toLowerCase().includes(patientName.toLowerCase())
                    : true; // If no patient name entered, don't filter by it.
        
                const isDoctorMatch = doctorName
                    ? item.consultantName.toLowerCase().includes(doctorName.toLowerCase())
                    : true; // If no doctor name entered, don't filter by it.
        
                return isPatientMatch && isDoctorMatch; // Both conditions must hold.
            });
        
            this.setState({ filteredData });
        };
        
        

        clearFilters = () => {
            this.setState({
                specificDate: null,
                tariff: '',
                patientName: '',
                doctorName: '',
                filteredData: [],
                tableVisible: false,
            });
        };


        render() {
            const { 
                filteredData,
                loading,
                error,
                tableVisible,
                isRestrictedFieldsVisible,
                tariffOptions,
                specificDate,
                patientName,
                doctorName,
                tariff,
            } = this.state;
            
            return (
                <div className="d-flex" id="wrapper">
                    <Side />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Top />
                            <Container fluid>
                                <div className="mb-2">
                                <h6 className="text-success" style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                                Chemo Plan Appointment Date List
                                </h6>
                                    <div className="float-right mb-2">
                                        <Button variant="outline-success" className="mr-2" onClick={this.exportToExcel}>
                                            Export to Excel
                                        </Button>
                                        <Button variant="outline-danger" onClick={this.exportToPDF}>
                                            Export to PDF
                                        </Button>
                                    </div>
                                </div>

                                <Row className="mb-3 align-items-end g-0">
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Patient Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search by patient name"
                                                name="patientName"
                                                value={this.state.patientName}
                                                onChange={this.handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Consultant Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Consultant name"
                                                name="doctorName"
                                                value={this.state.doctorName}
                                                onChange={this.handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Chemo Cycle Date</Form.Label>
                                            <DatePicker
                                                onChange={this.handleDateChange}
                                                format="DD-MM-YYYY"
                                                className="form-control"
                                                placeholder="Select date"
                                                value={this.state.specificDate}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {/* {this.state.isRestrictedFieldsVisible && (
                                        <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Tarrif</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="tariff"
                                                value={this.state.tariff}
                                                onChange={this.handleInputChange}
                                            >
                                                <option value="">Select Tarrif</option>
                                                {this.state.tariffOptions.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    )} */}
                                    <Col md="auto" className="d-flex  justify-content-start">
                                        <Button 
                                            variant="secondary" 
                                            onClick={this.handleSearch} 
                                            className="mb-3 px-4"
                                            
                                        >
                                            Search 
                                            {/* <FaTimesCircle className="ml-1" /> */}
                                        </Button>
                                    </Col>
                                    <Col md="auto" className="d-flex justify-content-start">
                                        <Button 
                                            variant="secondary" 
                                            onClick={this.clearFilters}
                                            className="mb-3 px-4"
                                        >
                                            Clear Filters 
                                            {/* <FaTimesCircle className="ml-1" /> */}
                                        </Button>
                                    </Col>
                                </Row>

                                <div className="table-responsive" style={{ maxHeight: '70vh' }}>
    {tableVisible && (
        <Table striped bordered hover className="mb-0">
        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#6c757d', color: 'white' }}>
            <tr>
            <th style={{ minWidth: '150px' }}>Patient Name</th>
            <th style={{ minWidth: '80px' }}>Age</th>
            <th style={{ minWidth: '80px' }}>Gender</th>
            <th style={{ minWidth: '120px' }}>DOB</th>
            <th style={{ minWidth: '100px' }}>MR No</th>
            <th style={{ minWidth: '200px' }}>Address</th>
            <th style={{ minWidth: '150px' }}>Contact Details</th>
            <th style={{ minWidth: '200px' }}>Diagnosis</th>
            <th style={{ minWidth: '150px' }}>Name of Consultant</th>
            <th style={{ minWidth: '200px' }}>Chemo Cycles Date</th>
            <th style={{ minWidth: '120px' }}>Referral Doctor</th>
            <th style={{ minWidth: '120px' }}>Followup Date</th>
            <th style={{ minWidth: '120px' }}>Discharge Date</th>
            <th style={{ minWidth: '120px' }}>Category</th>
            <th style={{ minWidth: '120px' }}>Company</th>
            <th style={{ minWidth: '120px' }}>Tariff</th>
            <th style={{ minWidth: '120px' }}>Pay Type</th>
            </tr>
        </thead>
        <tbody>
            {loading ? (
            <tr>
                <td colSpan={26} className="text-center py-4">
                Loading...
                </td>
            </tr>
            ) : error ? (
            <tr>
                <td colSpan={26} className="text-center py-4 text-danger">
                {error}
                </td>
            </tr>
            ) : filteredData.length === 0 ? (
            <tr>
                <td colSpan={26} className="text-center py-4">
                No records found.
                </td>
            </tr>
            ) : (
            filteredData.map((patient) =>
                patient.treatmentPlans.flatMap((plan) =>
                plan.chemoDetails.map((chemo, chemoIndex) => (
                    <tr key={`${patient.patientId}-${plan.planNo}-${chemoIndex}`}>
                    {/* Display all patient and plan details for each row */}
                    <td>{patient.patientName}</td>
                    <td>{patient.age}</td>
                    <td>{patient.gender}</td>
                    <td>{patient.dob}</td>
                    <td>{patient.mrNo}</td>
                    <td>{patient.address}</td>
                    <td>
                        {patient.phone}
                    </td>
                    <td>{patient.currentCancerSites || 'N/A'}</td>
                    <td>{patient.consultantName}</td>
                    
                    <td>{moment(chemo.chemoDate).format('DD-MM-YYYY')}</td>
                    <td>{patient.referralDoctorName}</td>  {/* New */}
                    <td>{patient.appointmentDt}</td>  {/* New */}
                    <td>{patient.dischargeDate}</td> {/* New */}
                    <td>{patient.category}</td>
                    <td>{patient.company}</td>
                    <td>{patient.tariff}</td>
                    <td>{patient.payType}</td>
                    </tr>
                ))
                )
            )
            )}
        </tbody>
        </Table>
    )}
    </div>




                            </Container>
                        </div>
                    </div>
                </div>
            );
        }
    }